class NotAvailableStrategy {
  public wrapWith() {
    return null;
  }
}

export { NotAvailableStrategy };
